import { createRouter,createWebHashHistory } from "vue-router";

export const routes = ([
    {
        path:'/',
        name:'产品选型',
        component:()=>import('@/views/SetupPage.vue')
    },
    {
        path: '/record',
        name: '选型记录',
        component: () => import('@/views/RecordPage.vue')
    },
])

const router = createRouter({
    history:createWebHashHistory(),
    routes:routes
})

export default router;